import { createFileRoute } from '@tanstack/react-router'

import AdviserReputationalTools from "@/modules/reputational-tools/adviser/index";
import {ADVISER_REPUTATIONAL_TOOLS_PATH, ADVISER_REPUTATIONAL_TOOLS_URL} from "@/utils/urls";

export const Route = createFileRoute(ADVISER_REPUTATIONAL_TOOLS_PATH)({
  component: AdviserReputationalToolsPage,
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Reputation', path: '#' },
        { label: 'Adviser marketing tools', path: ADVISER_REPUTATIONAL_TOOLS_URL },
      ],
      children: null
    }
  }
})

function AdviserReputationalToolsPage() {
  return (
    <div className={'flex flex-col items-center justify-center'}>
      <AdviserReputationalTools />
    </div>
  )
}
